import { render, staticRenderFns } from "./MSplit.vue?vue&type=template&id=00cd2da1&scoped=true&"
import script from "./MSplit.vue?vue&type=script&lang=ts&"
export * from "./MSplit.vue?vue&type=script&lang=ts&"
import style0 from "./MSplit.vue?vue&type=style&index=0&id=00cd2da1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cd2da1",
  null
  
)

export default component.exports